import { InfoTip } from '@mailflow/ui';
import { ERKLAERUNGEN, type ErklaerungKey } from '../lib/erklaerungen.js';

export interface InfoProps {
  /** Schlüssel aus der Sammlung der Erklärtexte. */
  zu: ErklaerungKey;
}

/**
 * Info-Knopf für einen Fachbegriff.
 *
 * Nimmt nur einen Schlüssel entgegen, keinen Text. Damit steht jeder Begriff
 * genau einmal erklärt — sonst hat derselbe Begriff nach ein paar Wochen an
 * drei Stellen drei verschiedene Erklärungen, und zwei davon sind veraltet.
 *
 * Verwendung: `<Info zu="warmup" />`
 */
export function Info({ zu }: InfoProps) {
  const eintrag = ERKLAERUNGEN[zu];
  return (
    <InfoTip term={eintrag.term} what={eintrag.what} why={eintrag.why} todo={eintrag.todo} />
  );
}
